import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { MessageCategory } from "model";
/**
* @class Message
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.message[0];
* const device = new Message(record);
* @property {NUMBER} _id - The id of the message
* @property {STRING} _message - The name of the message
* @property {BOOLEAN} _updatedDate - the updated date of the message
* @property {bcmsDate} _updatedTime - the updated time of the message
* @property {STRING} _from - where the message was generated from
* @property {STRING} _category - the category of the message
*/

export default class Message extends BCMSRecord {
    _id
    _message 
    _updatedDate
    _updatedTime
    _from
    _category
    _createdDate
    _createdTime
    _trackingID
    
    constructor (record){     
      super( record  ) 
    }
  }
Message.define({
    "recordType":"messages",
    "recordIDProp":"id",
    "className" : "Message",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the message
         * @property set {NUMBER} - sets the id of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name message
         * @instance
         * @property get {STRING} - gets the name of the message
         * @property set {STRING} - sets the name of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToString("message", "_message", "message"),

        /** 
         * @name updatedDate
         * @instance
         * @property get {STRING} - gets the updatedDate of the message
         * @property set {STRING} - sets the updatedDate of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToDate("updatedDate", "_updatedDate", "updatedDate"),

        /** 
         * @name updatedTime
         * @instance
         * @property get {STRING} - gets the updatedTime of the message
         * @property set {STRING} - sets the updatedTime of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToString("updatedTime", "_updatedTime", "updatedTime"),

        /** 
         * @name from
         * @instance
         * @property get {STRING} - gets the from description of the message
         * @property set {STRING} - sets the from description of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToString("from", "_from", "from"),

        /** 
         * @name category
         * @instance
         * @property get {STRING} - gets the category of the message
         * @property set {STRING} - sets the category of the message
         * @memberof Message 
         */
        BCMSRecordProperty.mapToClass("category", "_category", () => MessageCategory),

        /**
         * @name createdDate
         * @instance
         * @property get {BCMSDate} - gets the createdDate of the message
         * @property set {BCMSDate} - sets the createdDate of the message
         * @memberof Message
         */
        BCMSRecordProperty.mapToDate("createdDate", "_createdDate"),

        /**
         * @name createdTime
         * @instance
         * @property get {STRING} - gets the createdTime of the message
         * @property set {STRING} - sets the createdTime of the message
         * @memberof Message
         */
        BCMSRecordProperty.mapToString("createdTime", "_createdTime"),

        /**
         * @name trackingID
         * @instance
         * @property get {STRING} - gets the trackingID of the message
         * @property set {STRING} - sets the trackingID of the message
         * @memberof Message
         */
        BCMSRecordProperty.mapToString("trackingID", "_trackingID")
      ]
})




